import React, { useContext } from 'react';
import { Context } from './App';
import { Navigate, Outlet } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';

const PreventedRoutes = () => {
  const { user, isResolved } = useContext(Context);

  if (!isResolved)
    return (
      <div className="centerLoading">
        <CircularProgress />
      </div>
    );
  if (!user) return <Outlet />;
  return <Navigate to="/" replace={true} />;
};

export default PreventedRoutes;
